import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, AuthPipe, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { roleGuard } from './common/guards/roleGuard';

// const adminOnly = () => hasCustomClaim('admin');
const redirectUnauthorizedToLogin = (): AuthPipe => redirectUnauthorizedTo(['login']);
// const belongsToAccount = (next) => hasCustomClaim(`account-${next.params.id}`);

const routes: Routes = [
  {
    path: 'projects/:projectId',
    loadChildren: () => import('./invoices/invoices.module').then((m) => m.InvoicesModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'invoices',
    loadChildren: () => import('./invoices/invoices.module').then((m) => m.InvoicesModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'all-invoices',
    loadChildren: () => import('./invoices-list/invoices-list.module').then((m) => m.InvoicesListModule),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'recipients',
    loadChildren: () => import('./recipients/recipients.module').then((m) => m.RecipientsModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'products',
    loadChildren: () => import('./products/products.module').then((m) => m.ProductsModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'clients',
    loadChildren: () => import('./clients/clients.module').then((m) => m.ClientsModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'events',
    loadChildren: () => import('./events/events.module').then((m) => m.EventsModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'playground',
    loadChildren: () => import('./playground/playground.module').then((m) => m.PlaygroundModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'organizations',
    loadChildren: () => import('./organizations/organizations.module').then((m) => m.OrganizationsModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'memberships',
    loadChildren: () => import('./memberships/memberships.module').then((m) => m.MembershipsModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'company-settings',
    loadChildren: () => import('./companies/company.module').then((m) => m.CompanyModule),
    canActivate: [AuthGuard, roleGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
